'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'sack-dollar';
var width = 512;
var height = 512;
var aliases = [128176];
var unicode = 'f81d';
var svgPathData = 'M272 233.6C277.9 234.6 290.1 237.2 296.1 238.5C304.7 240.8 309.7 249.6 307.5 258.1C305.2 266.7 296.4 271.7 287.9 269.5C283.9 268.4 270.2 265.7 265.8 265C252.9 263 242.1 264.6 234.9 267.9C227.7 271.2 224.1 275.4 224.4 278.1C223.7 283.1 224.3 285.2 224.9 286.4C225.5 287.8 226.8 289.5 229.8 291.5C236.6 296.1 246.9 299.3 260.8 303.5L261.4 303.7C273.7 307.4 289.3 312.1 300.9 320.5C307.1 325 312.9 331.1 316.5 339.3C320.1 347.6 320.8 356.8 319.2 366.5C316.1 383.1 304.6 395.9 289.9 402.2C284.3 404.6 278.3 406.2 272 407.1V416C272 424.8 264.8 432 256 432C247.2 432 240 424.8 240 416V406.4C230.6 404.6 216.4 399.8 207.6 396.7C205.8 396.1 204.2 395.6 202.9 395.2C194.6 392.4 190 383.3 192.8 374.9C195.6 366.6 204.7 362 213.1 364.8C214.1 365.5 217.1 366.2 219.2 366.9C228.7 370.1 239.9 373.9 246.3 374.1C259.6 377 270.3 375.8 277.3 372.8C283.8 370 286.7 366.1 287.6 361C288.4 356.4 287.8 353.7 287.1 352.1C286.4 350.4 284.9 348.5 282 346.4C275.5 341.6 265.3 338.3 251.6 334.1L249.5 333.5C237.7 329.9 222.9 325.5 211.9 317.1C205.6 313.8 199.7 308 195.9 300.1C192.1 292 191.2 283 192.8 273.5C195.7 256.8 207.6 245.2 221.7 238.8C227.3 236.2 233.5 234.4 240 233.3V223.1C240 215.2 247.2 207.1 256 207.1C264.8 207.1 272 215.2 272 223.1L272 233.6zM179 120.4L121.9 37.62C110.1 21.7 122.4 0 141.7 0H370.3C389.6 0 401 21.7 390.1 37.62L332.1 120.4C340.7 125.4 349.7 131.4 359.4 138.5C420.8 183.7 512 273.4 512 416C512 469 469 512 416 512H96C42.98 512 0 469 0 416C0 273.4 91.2 183.7 152.6 138.5C162.3 131.4 171.3 125.4 179 120.4H179zM196.3 147.4C141.4 182.5 32 268.3 32 416C32 451.3 60.65 480 96 480H416C451.3 480 480 451.3 480 416C480 268.3 370.6 182.5 315.7 147.4L310.5 143.1H201.5L196.3 147.4zM299.9 111.1L355.1 31.1H156.9L212.1 111.1H299.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSackDollar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;